import { ReactElement } from 'react';

function Header(): ReactElement {
  return (
    <>
      <text
        x={700}
        y={60}
        fontSize={8}
        fill='white'
        stroke='white'
        strokeWidth={0.2}
      >
        115KV TO PG&E CANYON COUNTRY SUB
      </text>
      <text
        x={775}
        y={70}
        fontSize={8}
        fill='white'
        stroke='white'
        strokeWidth={0.2}
      >
        0.99 MI
      </text>
    </>
  );
}

export default Header;
